module.exports = __webpack_public_path__ + "static/jetpack-form@2x-006cac9868bbc82cd96356fe34d94ee3.png";